import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { getCurrentTerms } from './projectTypeUtils';

const ITEM_HEIGHT = 48;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5,
      width: 100,
    },
  },
};

const MultipleSelectComponent = (props) => {
  const { data, section, setSection } = props;
  const TERMS = getCurrentTerms()

  return (
    <div>
      <FormControl sx={{ m: 1, width: 100 }}>
        <InputLabel id="demo-multiple-checkbox-label" sx={{ lineHeight: '1', fontSize: '0.875rem' }}>{TERMS.SECTION_HEADER}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={section}
          onChange={setSection}
          input={<OutlinedInput label={TERMS.SECTION_HEADER} />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
          size="small"
          sx={{
            height: '40px',
            '.MuiOutlinedInput-input': {
              padding: '6px 14px',
              fontSize: '0.875rem'
            }
          }}
        >
          {data?.map((name) => (
            <MenuItem key={name} value={name} dense sx={{ minHeight: '32px' }}>
              <Checkbox size='small' checked={section.includes(name)} />
              <ListItemText
                sx={{ fontSize: '0.875rem', margin: 0 }}
                primary={name}
                primaryTypographyProps={{ fontSize: '0.875rem' }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default MultipleSelectComponent;